module.exports = __webpack_public_path__ + "static/media/Validation3.773a6575.png";